import { render, staticRenderFns } from "./PrivacyFooter.vue?vue&type=template&id=46ccb1f8&scoped=true&"
import script from "./PrivacyFooter.vue?vue&type=script&lang=js&"
export * from "./PrivacyFooter.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyFooter.vue?vue&type=style&index=0&id=46ccb1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccb1f8",
  null
  
)

export default component.exports